import { z } from 'zod'

export const FetchedDrawingSchema = z.object({
  size: z.string(),
  file: z.instanceof(Blob).nullable(),
  loading: z.boolean()
})
